import React from "react";
import { Mail, Phone, Instagram, Facebook } from "lucide-react";
import image1 from "../assets/image1.jpg";
import image2 from "../assets/image2.jpg";
import logo from "../assets/logo.jpg";

const images = [
  image1,
  image1,
  image2,
  image2,
  image1,
  image2,
  image1,
  image2,
  image1,
];

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 font-[Poppins] container mx-auto px-4 py-8">
      {/* Instagram Banner */}
      <div className="relative overflow-hidden border-t border-b border-gray-200 dark:border-gray-700 py-4">
        
        <div className="absolute inset-0 bg-gradient-to-r from-white/70 via-transparent to-white/70 dark:from-gray-900/80 dark:to-gray-900/80 z-10" />
        <div className="flex animate-scroll gap-1 relative z-0">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Property ${index + 1}`}
              className="w-[200px] h-[130px] object-cover transform transition-transform duration-500 hover:scale-110 hover:brightness-105"
            />
          ))}
        </div>
      </div>

      {/* Contact + Logo */}
      <div className="flex flex-col items-center py-10 space-y-6 md:space-y-0 md:flex-row md:justify-between md:items-center">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img src={logo} alt="Logo" className="w-25 h-16" />
          <div className="relative group inline-block cursor-pointer">
  {/* Text */}
  <h2
    className="text-3xl font-semibold text-gray-800 dark:text-white transition duration-300 hover:text-blue-600 hover:scale-105 active:scale-95"
  >
    - Devan Arora
  </h2>

  {/* Cartoon Bubble Tooltip */}
  <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-max bg-white dark:bg-gray-800 text-gray-800 dark:text-white text-sm px-3 py-1 rounded-xl shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 before:content-[''] before:absolute before:bottom-[-6px] before:left-1/2 before:-translate-x-1/2 before:border-8 before:border-transparent before:border-t-white dark:before:border-t-gray-800">
    Your Trusted Realtor 🏡
  </div>
</div>

        </div>

        {/* Contact Info */}
        <div className="flex flex-col md:flex-row items-center gap-6 text-sm text-gray-600 dark:text-gray-300">
          {/* Phone */}
          <a
            href="tel:+16475504350"
            className="flex items-center gap-2 transition-all duration-300 hover:text-green-600 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-green-400 rounded px-2 py-1"
          >
            <Phone className="w-4 h-4" />
            <span className="font-medium">+1 (647) 550 4350</span>
          </a>

          {/* Email */}
          <a
            href="mailto:Realtordevanarora@gmail.com"
            className="flex items-center gap-2 transition-all duration-300 hover:text-blue-600 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded px-2 py-1"
          >
            <Mail className="w-4 h-4" />
            <span className="font-medium">Realtordevanarora@gmail.com</span>
          </a>
        </div>

        {/* Social Icons */}
        <div className="flex space-x-4">
          <a
            href="https://www.facebook.com"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-blue-600 dark:hover:bg-blue-600 text-gray-600 dark:text-gray-300 hover:text-white transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook className="w-5 h-5" />
          </a>
          <a
            href="https://www.instagram.com"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-pink-500 dark:hover:bg-pink-500 text-gray-600 dark:text-gray-300 hover:text-white transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>

      {/* Legal Links */}
      <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700 px-6 py-4">
        <div className="flex space-x-4 mb-2 md:mb-0">
          <button
            onClick={() => alert("Terms & Conditions clicked")}
            className="hover:underline transition"
          >
            Terms & Conditions
          </button>

          <button
            onClick={() => alert("Privacy Policy clicked")}
            className="hover:underline transition"
          >
            Privacy Policy
          </button>
        </div>
        <p>
          &copy; {new Date().getFullYear()} Devan Arora. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
